import App from '../../../../app';
import { REPORT_4XX__RETRY_REPORT_500 } from '../../../../constants';
import { storeUserPreferences } from '../api/package/pam/pam-api';
import type { PrefKey } from '../api/package/pam/pam-domain';

export async function storePreferences(key: PrefKey, value: any): Promise<void> {
  if (!window.$app.loginStore.value.jwt) {
    throw new Error('User is not authorized');
  }

  if (!window.$app.loginStore.value.preferences) {
    throw new Error('Preferences not yet initialized');
  }

  return await App.instance.http
    .call(
      window.$app.appConfig.apiUrl_pam,
      storeUserPreferences(window.$app.loginStore.value.jwt, [
        {
          key,
          value,
        },
      ]),
      REPORT_4XX__RETRY_REPORT_500,
    )
    .then((ok: boolean) => {
      if (ok) {
        window.$app.logger.log('preferences stored');
      } else {
        window.$app.logger.log('storing preferences failed');
      }
    });
}
